/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
export enum UserType {
  /// <summary>
  /// CK: for Internal Orbit users, they are differentiated as Super User or Customer Services - there will be more at a later date
  /// </summary>
  InternalOrbit = 1,
  /// <summary>
  /// CK: for Organisers users, there is no differentiation - let's call the Role Organiser Admin - there may be more at a later date
  /// </summary>
  Organiser = 2,
  /// <summary>
  /// CK: for Customer users, there is no differentiation one - let's call the Role Customer - there may be more at a later date
  /// </summary>
  Customer = 3,
  /// <summary>
  /// KS0008328: A user can be both an Organiser and a Customer apparantly..
  /// </summary>
  OrganiserAndCustomer = 4,
}
